module.exports = __webpack_public_path__ + "img/ourServices_hero_wGradient.8ea793cd.png";